import API from "./api";
import { environment } from "../environments/env";
import { route } from "./routeDictionary";

export default {
  uploadMedia(file) {
    const formData = new FormData();
    formData.append("file", file);

    return API.post(`${environment.apiUri}${route.UploadFile}`, formData, {
      headers: { "Content-Type": "application/json" },
    });
  },
  async getCalendarSchedule(dateInit, dateFinal) {
    return API.get(
      `${environment.apiUri}${route.InstagramMediaSchedule}?data_inicio=${dateInit}&data_fim=${dateFinal}`
    );
  },
  uploadMediaToContainer(media) {
    return API.post(
      `${environment.apiUri}${route.InstagramMediaContainerV2}`,
      media,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },
  GetAllOrFiltered(SelectedStores) {
    if (SelectedStores) {
      return API.get(
        `${environment.apiUri}${route.GetAllOrFilteredInstagrams}?instaPageId=${SelectedStores}``${environment.apiUri}${route.GetAllOrFilteredInstagrams}?instaPageId=${SelectedStores}`
      );
    } else {
      return API.get(
        `${environment.apiUri}${route.GetAllOrFilteredInstagrams}`
      );
    }
  },
  registerPost(post) {
    return API.post(
      `${environment.apiUri}${route.InstagramPostMediaV2}`,
      post,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },
  registerPostScheduled(post) {
    return API.post(
      `${environment.apiUri}${route.InstagramMediaScheduled}`,
      post,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },
  getImageFromLibraryById(id) {
    return API.get(
      `${environment.apiUri}${route.InstagramLibraryUploadGetImage}?InstagramLibraryMediaId=${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },
  getxls(data) {
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const currentDate = new Date();
    const monthpass = new Date(currentDate.setDate(currentDate.getDate() - 7));
    if (data.inicio == undefined && data.fim == undefined) {
      return API.post(
        `${environment.apiUri}${
          route.ReportXls
        }?data_inicio=${monthpass.toISOString()}&data_fim=${today.toISOString()}`,
        data.stores,
        { responseType: "arraybuffer" }
      );
    } else {
      return API.post(
        `${environment.apiUri}${route.ReportXls}?data_inicio=${data.inicio}&data_fim=${data.fim}`,
        data.stores,
        { responseType: "arraybuffer" }
      );
    }
  },
  getCategoryWithMedias() {
    return API.get(`${environment.apiUri}${route.GetCategoryWithMedias}`);
  },
  getAllMedias(data) {
    if (data.isCalendar) {
      return API.get(
        `${environment.apiUri}${route.GetAllMedias}?data_inicio=${data.startDate}&Schedule=True`
      );
    }
    if (data.isPosts && data.isScheduled) {
      if (data.name.length > 0) {
        return API.get(
          `${environment.apiUri}${route.GetAllMedias}?caption=${data.name}?Schedule=True&PublishStatus=False&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      } else {
        return API.get(
          `${environment.apiUri}${route.GetAllMedias}?Schedule=True&PublishStatus=False&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      }
    }
    if (data.isPosts && !data.isScheduled) {
      if (data.name.length > 0) {
        return API.get(
          `${environment.apiUri}${route.GetAllMedias}?caption=${data.name}&PublishStatus=True&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      } else {
        return API.get(
          `${environment.apiUri}${route.GetAllMedias}?PublishStatus=True&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      }
    }
    if (data.byId) {
      if (data.id != undefined) {
        return API.get(
          `${environment.apiUri}${route.GetAllMedias}?id=${data.id}`
        );
      } else if (data.instaMediaId != undefined) {
        return API.get(
          `${environment.apiUri}${route.GetAllMedias}?instaMediaId=${data.instaMediaId}`
        );
      }
    }
  },
  getScheduledMedias(data) {
    if (data.isCalendar) {
      return API.get(
        `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=${data.startDate}&Schedule=True`
      );
    }
    if (data.isPosts && data.isScheduled) {
      if (data.name.length > 0) {
        return API.get(
          `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=01/01/0001&caption=${data.name}?Schedule=True&PublishStatus=False&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      } else {
        return API.get(
          `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=01/01/0001&Schedule=True&PublishStatus=False&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      }
    }
    if (data.isPosts && !data.isScheduled) {
      if (data.name.length > 0) {
        return API.get(
          `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=01/01/0001&caption=${data.name}&PublishStatus=True&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      } else {
        return API.get(
          `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=01/01/0001&PublishStatus=True&Limit=${data.limit}&Offset=${data.offset}&Sort=-timestamp`
        );
      }
    }
    if (data.byId) {
      if (data.id != undefined) {
        return API.get(
          `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=01/01/0001&id=${data.id}`
        );
      } else if (data.instaMediaId != undefined) {
        return API.get(
          `${environment.apiUri}${route.InstagramMediasScheduledMediasV2}?data_inicio=01/01/0001&instaMediaId=${data.instaMediaId}`
        );
      }
    }
  },
};
